//src/components/rental-managers/GetStartedSection.jsx

import React from 'react';
import { Box, Typography, Button, List, ListItem, ListItemText } from '@mui/material';
import GetStartedStyles from './GetStartedSection.styles';

const GetStartedSection = () => {
  return (
    <Box sx={GetStartedStyles.container}>
      {/* "Get Started" Button with Arrow */}
      <Box sx={GetStartedStyles.buttonContainer}>
        <Button variant="contained" 
        sx={GetStartedStyles.getStartedButton}
        onClick={() => window.location.href = '/login'}
        >
          Get Started
        </Button>
        <Box sx={GetStartedStyles.arrow}></Box>
      </Box>

      {/* Heading */}
      <Typography variant="h6" sx={GetStartedStyles.heading}>
        What You’ll Need To Get Started
      </Typography>

      {/* Subheading */}
      <Typography variant="body1" sx={GetStartedStyles.subheading}>
        <strong>If your profile or properties will not be added with property management software integrations,</strong>{' '}
        we’ll need to verify ownership or legal purpose for access, including:
      </Typography>

      {/* Requirements List */}
      <List sx={GetStartedStyles.list}>
        {[
          'PROOF OF OWNERSHIP - CLOSING DOCUMENTS, DEED, OR COUNTY OWNERSHIP INFORMATION WITH MATCHING ID. FOR ENTITY OWNERS: BUSINESS FORMATION DOCUMENTS, SIGNING AUTHORITY AND ID',
          'ID Verify',
          'Camera use to ID verify',
          'PROPERTY MANAGERS MANAGING FOR OTHERS WILL NEED TO BE LICENSED AND PROVIDE MANAGEMENT AGREEMENTS FOR EACH PROPERTY ADDED.',
        ].map((requirement, index) => (
          <ListItem key={index} sx={GetStartedStyles.listItem}>
            <ListItemText
              primary={
                <Typography component="span" sx={requirement.includes(':') ? GetStartedStyles.boldText : null}>
                  {requirement}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>

      {/* Disclaimer */}
      <Typography variant="body2" sx={GetStartedStyles.disclaimer}>
        PLEASE UNDERSTAND THAT WE WANT TO MAKE SURE THAT WE PRIORITIZE MAINTAINING THE PUBLIC’S TRUST. WE DO OUR BEST TO PREVENT IDENTITY 
        THIEVES FROM USING OUR SERVICES TO GAIN ACCESS TO PROPERTIES THEY DO NOT OWN, AND WE INTEND TO MAKE A DENT IN RENTAL SCAMS THAT 
        ARE HARMING VULNERABLE FAMILIES BY VERIFYING OWNERSHIP OR LEGAL PURPOSE BEFORE OUR SHOWING SERVICES CAN BE DEPLOYED.
      </Typography>
    </Box>
  );
};

export default GetStartedSection;
